import * as stylex from "@stylexjs/stylex";

import type { CSSProperties, PropsWithChildren, ReactNode } from "react";

type ContentEdgeStyle = CSSProperties & { readonly "--content-edge": string };
const unframedStyle: ContentEdgeStyle = { "--content-edge": "184px" };
const contentStyle: ContentEdgeStyle = { "--content-edge": "280px" };

type SignedInRailViewProps = Readonly<
  PropsWithChildren<{
    readonly enabled: boolean;
    readonly sidebar: ReactNode;
  }>
>;

export function SignedInRailView({
  enabled,
  sidebar,
  children,
}: SignedInRailViewProps) {
  if (!enabled)
    return (
      <div {...stylex.props(styles.unframed)} style={unframedStyle}>
        {children}
      </div>
    );

  return (
    <div {...stylex.props(styles.rail)}>
      {sidebar}
      <div
        data-rail="true"
        {...stylex.props(styles.content)}
        style={contentStyle}
      >
        {children}
      </div>
    </div>
  );
}

const styles = stylex.create({
  rail: { display: "flex", alignItems: "flex-start" },
  content: { minWidth: 0, flex: 1 },
  unframed: { display: "contents" },
});
